import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyInput from 'react-currency-input';
import {PowerSelect} from 'react-power-select';
import 'react-power-select/dist/react-power-select.css';
import CompaniesDropdown from '../companies/companies-dropdown.jsx';

export default class AddNewDriver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
      pickupAddressValidated: false,
      dropoffAddressValidated: false,
      pickupAddressLatt: null,
      pickupAddressLong: null,
      dropoffAddressLatt: null,
      dropoffAddressLong: null,
      driver_expense_account_limit_in_pence: 0,
      driver_expense_account_limit_value_formatted: '',
      driver_expense_account_current_total_value_in_pence: 0,
      driver_expense_account_current_total_value_formatted: '',
      driverPriceOption:'',
      isOtherDriverPrice:false
    };
    this.handleAddNewDriverCreate = this.handleAddNewDriverCreate.bind(this);
    this.handleFileConvert = this.handleFileConvert.bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
  }

  handleCustomerSelection(option) {
    this.setState({selectedCustomerId: option.id});
  }
  handleDriverPriceOption(e){
    if(e.currentTarget.value == 'other'){
      this.setState({isOtherDriverPrice:true,driverPriceOption:''});
    }else{
      this.setState({driverPriceOption:e.currentTarget.value,isOtherDriverPrice:false});
    }
  }
  handleDriverPriceOptionText(e){
    this.setState({driverPriceOption:e.currentTarget.value});
  }
  handleAddNewDriverCreate(e) {
    e.preventDefault();
    let newDriverData = {
      api_token: window.api_token,
      company_id:  $('[name=company-id]').val(),
      home_address: {
        postcode: $('[name=home_address_postcode]').val(),
        house_number_or_name: $('[name=home_address_house_number_or_name]').val(),
        address_line_1: $('[name=home_address_address_line_1]').val(),
        address_line_2: $('[name=home_address_address_line_2]').val(),
        address_line_3: $('[name=home_address_address_line_3]').val(),
        town_city: $('[name=home_address_town_city]').val(),
        county_area: $('[name=home_address_county_area]').val(),
        country: $('[name=home_address_country]').val(),
      },
      driver_first_name: $('[name=driver_first_name]').val(),
      driver_last_name: $('[name=driver_last_name]').val(),
      driver_trade_plate_number: $('[name=driver_trade_plate_number]').val(),
      driver_price_option: this.state.driverPriceOption,
      driver_got_uniform: $('[name=driver_got_uniform]:checked').val(),
      driver_got_tablet: $('[name=driver_got_tablet]:checked').val(),
      driver_got_id_card: $('[name=driver_got_id_card]:checked').val(),
      driver_got_breakdown_cover: $(
        '[name=driver_got_breakdown_cover]:checked').val(),
      driver_points_on_license: $(
        '[name=driver_points_on_license]').val(),

      driver_email: $('[name=driver_email]').val(),

      driver_expense_account_limit_in_pence: this.state.driver_expense_account_limit_in_pence,
      driver_expense_account_limit_value_formatted: this.state.driver_expense_account_limit_value_formatted,
      driver_expense_account_current_total_value_in_pence: this.state.driver_expense_account_current_total_value_in_pence,
      driver_expense_account_current_total_value_formatted: this.state.driver_expense_account_current_total_value_formatted,

      image: $('#b64').val(),
      image_of_id_card: $('#b64-id-card').val(),
      driver_password: $('[name=driver_password]').val(),
      contact_number: $('[name=contact_number]').val(),
      emergency_contact: $('[name=emergency_contact]').val(),
      emergency_contact_number: $('[name=emergency_contact_number]').val(),
      fuel_card_number : $('[name=fuel_card_number]').val()
    }

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/add-new-driver',
      data: newDriverData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Driver Created');
          $('#infomodal .modal-body').html('New Driver Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
        }
        else {
          $('#infomodallabel').html('Error adding new driver');
          $('#infomodal .modal-body').html($.parseHTML(response.responseText.replace(/\"/g, "")));
          $('#infomodal').modal();
        }
      }
    });
  }


  handleFileConvert() {
    let uploadInput = document.getElementById('inp');
    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById("img").src = e.target.result;
        document.getElementById("b64").value = e.target.result;
      });
      fileReader.readAsDataURL(uploadInput.files[0]);
    }
    else {
      console.log('not converted properly.');
    }
  }

  handleFileConvertOfIdCard() {
    let uploadInput = document.getElementById('inp_id_card');
    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener("load", function(e) {
        document.getElementById("img-id-card").src = e.target.result;
        document.getElementById("b64-id-card").value = e.target.result;
      });
      fileReader.readAsDataURL( uploadInput.files[0] );
    }
    else {
      console.log('not converted properly.');
    }
  }

  toggleAddNewDriver(e) {
    $('#add_new_driver_form').slideToggle();
    $('.add-new-driver-button').toggleClass('text-center').toggleClass('opened-button-for-slidedown-content');
    $('#slide-toggle-icon').toggleClass('fa-minus-circle');
    $('#react-component-g4-logistics-portal-add-new-driver').toggleClass('active');
  }


  render() {
    return (
      <div>
        <button className="text-center btn btn-lg btn-light add-new-driver-button"
                type="button" onClick={this.toggleAddNewDriver}>
          <i className="fa fa-plus-circle" id="slide-toggle-icon"></i>&nbsp;
          Add New Driver
        </button>

        <form id="add_new_driver_form" ref="addNewDriverForm">
          <fieldset>
            <br />
            <br />
            <h1>Add New Driver</h1>
            <br />

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Driver Company</label>
                  <CompaniesDropdown />
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="driver_first_name">Driver First Name</label>
                      <input type="text" name="driver_first_name" id="driver_first_name"
                             className="form-control form-control-lg" />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="driver_last_name">Driver Last Name</label>
                      <input type="text" name="driver_last_name" id="driver_last_name"
                             className="form-control form-control-lg" />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="driver_points_on_license">Driver Points on License</label>
                      <input type="text" name="driver_points_on_license" id="driver_points_on_license"
                             className="form-control form-control-lg text-center" maxLength="2" />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="contact_number">Driver Contact Phone Number</label>
                      <input type="text" className="form-control form-control-lg"
                             name="contact_number" id="contact_number" required />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="driver_trade_plate_number">Driver Trade Plate Number</label>
                      <input type="text" name="driver_trade_plate_number" id="driver_trade_plate_number"
                             className="form-control form-control-lg" />
                    </div>
                  </div>
                </div>
<hr />
                <div className="row text-center">
                  <div className="col-md-6">
                    <label>
                      Has this driver got their Uniform?
                    </label>

                    <div className="btn-group btn-group-toggle driver-uniform-form-radio-container text-center"
                         data-toggle="buttons">
                      <label className="btn btn-secondary yes-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="driver_got_uniform"
                               type="radio" value="1" required /> YES
                      </label>
                      <label className="btn btn-secondary no-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="driver_got_uniform"
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label>
                      Has this driver got their Tablet?
                    </label>

                    <div className="btn-group btn-group-toggle driver-tablet-form-radio-container text-center"
                         data-toggle="buttons">
                      <label className="btn btn-secondary yes-driver-tablet">
                        <input className="form-control form-control-lg"
                               name="driver_got_tablet"
                               type="radio" value="1" required /> YES
                      </label>
                      <label className="btn btn-secondary no-driver-tablet">
                        <input className="form-control form-control-lg"
                               name="driver_got_tablet"
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>
                </div>
                  <p>&nbsp;</p>
                  <div className="row text-center">
                    <div className="col-md-6">
                      <label>
                        Has this driver got their ID Card?
                      </label>

                      <div className="btn-group btn-group-toggle driver-id-card-form-radio-container text-center"
                           data-toggle="buttons">
                        <label className="btn btn-secondary yes-driver-id-card">
                          <input className="form-control form-control-lg"
                                 name="driver_got_id_card"
                                 type="radio" value="1" required /> YES
                        </label>
                        <label className="btn btn-secondary no-driver-id-card">
                          <input className="form-control form-control-lg"
                                 name="driver_got_id_card"
                                 type="radio" value="0" required /> NO
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label>
                        Has this driver got breakdown cover?
                      </label>

                      <div className="btn-group btn-group-toggle driver-breakdown-cover-form-radio-container text-center"
                           data-toggle="buttons">
                        <label className="btn btn-secondary yes-driver-breakdown-cover">
                          <input className="form-control form-control-lg"
                                 name="driver_got_breakdown_cover"
                                 type="radio" value="1" required /> YES
                        </label>
                        <label className="btn btn-secondary no-driver-breakdown-cover">
                          <input className="form-control form-control-lg"
                                 name="driver_got_breakdown_cover"
                                 type="radio" value="0" required /> NO
                        </label>
                      </div>
                    </div>

                </div>
<hr />

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="driver_email">Driver Email (used for driver app)</label>
                      <input type="text" name="driver_email" id="driver_email"
                             className="form-control form-control-lg" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="driver_password">Driver Password (used for driver app)</label>
                      <input type="text" name="driver_password" id="driver_password"
                             className="form-control form-control-lg" />
                    </div>
                  </div></div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="emergency_contact">Driver Emergency Contact Name</label>
                      <input type="text" className="form-control form-control-lg"
                             name="emergency_contact" id="emergency_contact" required />
                    </div>

                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="emergency_contact_number">Driver Emergency Contact Number</label>
                      <input type="text" className="form-control form-control-lg"
                             name="emergency_contact_number" id="emergency_contact_number" required />
                    </div>
                  </div>
                </div>
                <h3>Home Address</h3>
                <br />
                <div className="form-group address-finder">
                  Address Finder:
                  <div id="home_address_postcode_lookup"></div>
                </div>



                <div className="form-group">
                  <label htmlFor="home_address_house_number_or_name">House Number or Name:</label>
                  <input type="text" name="home_address_house_number_or_name"
                         id="home_address_house_number_or_name" className="form-control form-control-lg"  />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_1">Address Line 1:</label>
                  <input type="text" name="home_address_address_line_1"
                         id="home_address_address_line_1" className="form-control form-control-lg"  required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_2">Address Line 2:</label>
                  <input type="text" name="home_address_address_line_2"
                         id="home_address_address_line_2" className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_3">Address Line 3:</label>
                  <input type="text" name="home_address_address_line_3"
                         id="home_address_address_line_3" className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_town_city">Town/City:</label>
                  <input type="text" name="home_address_town_city"
                         id="home_address_town_city" className="form-control form-control-lg" required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_county_area">County/Area</label>
                  <input type="text" name="home_address_county_area"
                         id="home_address_county_area" className="form-control form-control-lg" required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_country" required>Country:</label>
                  <input type="text" name="home_address_country"
                         id="home_address_country" className="form-control form-control-lg"  required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_postcode">Postcode:</label>

                  <input type="text" name="home_address_postcode"
                         id="home_address_postcode" className="form-control form-control-lg" required />

                </div>
              </div>
              <div className="col-md-6">
                <h3>Driver Expense Account settings</h3>
                <div className="row">
                  <div className="col-md-6">
                    Expense Account Limit:
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.driver_expense_account_limit_in_pence/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            driver_expense_account_limit_in_pence: (floatValue*100),
                            driver_expense_account_limit_value_formatted: maskedValue,
                          });
                        }
                      }
                    />

                  </div>
                  <div className="col-md-6">
                    Expense Account Current Total Value:
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.driver_expense_account_current_total_value_in_pence/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            driver_expense_account_current_total_value_in_pence: (floatValue*100),
                            driver_expense_account_current_total_value_formatted: maskedValue,
                          });
                        }
                      }
                    />
                  </div>
                </div>

                <div className="form-group image-upload-container">
                  <h2 htmlFor="driver_picture">Driver Photo</h2>
                  <input id="inp" type='file' onChange={this.handleFileConvert} className="form-control" />
                  <input type="hidden" name="image-base-64" id="b64" />
                  <img id="img" />
                </div>

                <div className="form-group image-upload-container-for-id-card">
                  <h2
                    htmlFor="driver_picture_of_id_card">
                    Driver Photo of ID Card
                  </h2>

                  <input
                    id="inp_id_card" type="file"
                    onChange={this.handleFileConvertOfIdCard}
                    className="form-control"
                  />

                  <input type="hidden" name="image-base-64-id-card" id="b64-id-card" />

                  <img id="img-id-card" />

                </div>
                
                <div className="row">
                  <div className="col-md-12">
                  <h2 className="d-inline">Driver Price Options</h2>
                    &nbsp;<i data-toggle="tooltip" title="Base is 70 Miles, (i.e if you select 28, then for 70 Miles it is fixed 28£ and then after per mile 0.20£)" className="d-inline fa fa-question-circle "></i>
                  </div>
                  <div className="col-md-12">
                    <div>
                        {/* <label className="radio-inline job-ref-font20">
                          <input type="radio" name="driver_price_radio" value="28" 
                          defaultChecked={false}
                          onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 28/20 &nbsp;
                        </label> */}

                        <label className="radio-inline job-ref-font20">
                          <input type="radio" name="driver_price_radio" value="30" 
                          defaultChecked={false}
                          onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/24 &nbsp;
                        </label>

                        <label className="radio-inline job-ref-font20">
                          <input type="radio" name="driver_price_radio" value="30/30" 
                          defaultChecked={false}
                          onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/30 &nbsp;
                        </label>

                        <label className="radio-inline job-ref-font20">
                          <input type="radio" name="driver_price_radio" value="30/34" 
                          defaultChecked={false}
                          onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 30/34 &nbsp;
                        </label>
                        
                        {/* <label className="radio-inline job-ref-font20">
                          <input type="radio" name="driver_price_radio"  value="other" 
                          defaultChecked={false}
                          onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; Other
                        </label> */}
                    </div>
                    {(this.state.isOtherDriverPrice) ? 
                      <div>
                        <input type="text" name="driver_price_radio_text" 
                        className="form-control form-control-lg" 
                        placeholder="Enter amount"
                        value={this.state.driverPriceOption}
                        onChange={(e)=>this.handleDriverPriceOptionText(e)}/>
                      </div>
                    : null}
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-12">
                    <h2 className="d-inline">Driver Fuel card number</h2>
                    <input type="text" className="form-control form-control-lg" name="fuel_card_number" id="fuel_card_number" required />
                  </div>
                </div>

              </div>

            </div>

            <div className="text-center">
              <button className="btn btn-lg btn-primary" onClick={this.handleAddNewDriverCreate} type="button"> Add New Driver </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}


class CustomersPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customers: props.customersAll || []
    };
    this.handleChange = this.handleChange.bind(this);

  }
  componentDidMount() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/customers",
      data: {api_token: window.api_token},
      cache: false
    })
      .done(function(customersJson) {
        that.setState({customers: customersJson});
      });
  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option,
    })
    this.props.handleCustomerSelection(option);


  }

  render() {
    return (
      <PowerSelect
        options={this.state.customers}
        optionLabelPath="name"
        selected={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Customer -- "
        required
      />
    )
  }
}

class CustomerDropDownItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customer: props.data
    };

  }

  render() {
    return (
      <option value={this.props.data.id}> {this.props.data.name}</option>
    )
  }
}



if (document.getElementById('react-component-g4-logistics-portal-add-new-driver')) {
  ReactDOM.render(<AddNewDriver />, document.getElementById('react-component-g4-logistics-portal-add-new-driver'));
}
